// extracted by mini-css-extract-plugin
module.exports = {"cookieType":"CookieType-module--cookie-type--eLk0S","container":"CookieType-module--container--2bLrc"};